var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.url
    ? _c(
        "a",
        {
          staticClass: "category-discount-title category-discount-title--link",
          attrs: { href: _vm.url },
        },
        [
          _c(
            "svg",
            {
              staticClass: "category-discount-title__icon",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z",
                },
              }),
              _vm._v(" "),
              _c("line", { attrs: { x1: "7", y1: "7", x2: "7.01", y2: "7" } }),
            ]
          ),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.$translate("OD3dprimaV2::Template.categoryDiscountTitle")
              )
            ),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "category-discount-title__arrow",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 9 16",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
              },
            },
            [_c("path", { attrs: { d: "M1 1l6.364 7L1 15" } })]
          ),
        ]
      )
    : _c("b", { staticClass: "category-discount-title" }, [
        _vm._v(
          _vm._s(_vm.$translate("OD3dprimaV2::Template.categoryDiscountTitle"))
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }